import {useGlobalStore} from '@/hooks/useGlobalStore';
import * as types from '@/types/music_sniper_types';
import {plural} from '@/utils';

type FilesProps = {
    files: types.FileData[];
}

export const Files = ({files}: FilesProps) => {
    const globalStore = useGlobalStore();

    return (
        <div className='files'>
            <span>+ Files</span>
            {files.map((file) => {
                const numComments = globalStore.getCommentsForFile(file.id).length;

                return (
                    <div
                        key={file.id}
                        id={file.id}
                    >
                        {file.title}
                        <br/> <br/>
                        {numComments}
                        {' '}
                        {plural('Comment', numComments)}
                    </div>
                );
            })}
        </div>
    );
};
